import { render } from "./RomaSayilari.vue?vue&type=template&id=6498c472"
import script from "./RomaSayilari.vue?vue&type=script&lang=js"
export * from "./RomaSayilari.vue?vue&type=script&lang=js"

import "./RomaSayilari.vue?vue&type=style&index=0&id=6498c472&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__